import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sg/garnish';

export const OrderStatusDivider = () => {
  const { match } = useResponsive();

  return (
    <View
      style={[styles.divider, match([styles.dividerXS, styles.dividerSM])]}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  divider: {
    height: 8,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
    marginHorizontal: -theme.spacing['10'],
  },
  dividerXS: {
    marginVertical: theme.spacing['6'],
  },
  dividerSM: {
    marginVertical: theme.spacing['10'],
  },
});
